import BaseClientError from "@/core/errors/BaseClientError";

export default class DriverExecutionError extends BaseClientError {
  constructor(error: unknown) {
    super(error, " el driver");
  }
}
